import React from "react";
import styled from "styled-components";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Link } from "react-router-dom";
import { MultiAvatar } from "@sonder/ui/source/styled/components/MultiAvatar";
import { colors } from "@sonder/ui/source/styled/theme";
import { TaskData } from "core/queries/GetTask";
import { GetUnitTasksTaskData } from "core/queries/GetUnitTasks";
import {
  GetUserRelatedBookingInquiryTasksData,
  GetUserRelatedBookingLeaseInquiryTasksData,
  GetUserRelatedTasksPaginatedData,
} from "core/queries/GetUserRelatedTasks";
import {
  getTaskAssigneeIds,
  getTaskAssigneeNames,
  getTaskCompanyIds,
} from "core/queries/mappers";
import { AssigneePicker } from "tasks/components/AssigneePicker";
import {
  convertToMoment,
  isSpaceCleanTask,
  parseGraphQLId,
} from "tasks/helpers";

const AssigneeName = styled.div`
  color: ${colors.gray6};
  font-size: 0.857rem;
  line-height: 1.143rem;
`;

const DueDate = styled.div`
  color: ${colors.gray4};
  font-size: 0.857rem;
  line-height: 1.143rem;

  &:hover {
    color: ${colors.black};
  }
`;

const StyledChevronRightIcon = styled(ChevronRightIcon)`
  margin-left: 0.5rem;
  visibility: hidden;
`;

const Container = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 0.571rem 0.964rem 0.571rem 1.714rem;
  text-decoration: none;

  &:hover {
    background-color: ${colors.grayF};
    cursor: pointer;

    ${StyledChevronRightIcon} {
      visibility: visible;
    }
  }
`;

const TaskDetails = styled.div`
  flex: 1;

  margin-left: 1.143rem;
  margin-right: 0.5rem;
  min-width: 0;
`;

const TaskName = styled.div`
  color: ${colors.gray1};
  font-size: 1rem;
  line-height: 1.429rem;
  margin-top: 0.286rem;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface TaskCellProps {
  eventName: string;
  task:
    | GetUnitTasksTaskData
    | GetUserRelatedBookingInquiryTasksData
    | GetUserRelatedBookingLeaseInquiryTasksData
    | GetUserRelatedTasksPaginatedData;
}
export const TaskCell = ({ eventName, task }: TaskCellProps) => {
  const { city, dueAt, id: taskId, name: taskName, type } = task;
  const dueAtMoment = convertToMoment(dueAt);
  const dueAtText = dueAtMoment ? dueAtMoment.format("MMM D") : "Due Date";

  return (
    <Container to={`/tasks/${parseGraphQLId(taskId)}`}>
      <AssigneePicker
        assigneeIds={getTaskAssigneeIds(task as TaskData)}
        companyIds={getTaskCompanyIds(task as TaskData)}
        disabled={isSpaceCleanTask(type)}
        eventName={eventName}
        renderTrigger={({ assignees }) => (
          <MultiAvatar
            avatars={assignees}
            maxLength={3}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        )}
        taskCityId={city?.id}
        taskId={taskId}
      />
      <TaskDetails>
        <AssigneeName>{getTaskAssigneeNames(task as TaskData)}</AssigneeName>
        <TaskName>{taskName}</TaskName>
      </TaskDetails>
      {dueAtMoment && (
        <DueDate
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {dueAtText}
        </DueDate>
      )}
      <StyledChevronRightIcon htmlColor={colors.black} />
    </Container>
  );
};
